import { render, staticRenderFns } from "./OtherOverheads.vue?vue&type=template&id=5abff32a"
import script from "./OtherOverheads.vue?vue&type=script&lang=js"
export * from "./OtherOverheads.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports